// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
=========================================================
* Mobile Responsive Enhancement for my-hts
* 모바일 환경 반응형 개선 스타일시트
=========================================================
*/

/* ===================================
   1. 모바일 기본 레이아웃 (< 768px)
   =================================== */

@media (max-width: 767px) {
  /* Body 및 기본 레이아웃 */
  body {
    padding: 0;
    font-size: 14px;
  }

  /* 레이아웃 전체 조정 */
  .layout-dashboard .ant-layout {
    margin-left: 0 !important;
    width: 100% !important;
  }

  .layout-dashboard .ant-layout-header {
    margin: 5px 8px !important;
    padding: 12px !important;
  }

  .layout-dashboard .ant-layout-content {
    margin: 0 8px !important;
    padding: 0 !important;
  }

  .layout-dashboard .ant-layout-footer {
    margin: 0 8px 8px !important;
    padding: 12px !important;
  }

  /* 사이드바 숨김 처리 (Drawer 밖의 고정 사이드바만) */
  .layout-dashboard > .ant-layout-sider.sider-primary {
    display: none !important;
  }

  /* Drawer 안의 사이드바는 보이도록 설정 */
  .drawer-sidebar .ant-layout-sider.sider-primary {
    display: block !important;
    position: relative !important;
    margin: 0 !important;
    padding: 0 !important;
    height: auto !important;
  }

  /* Drawer 내부 레이아웃 조정 */
  .drawer-sidebar .layout-dashboard {
    background: transparent !important;
  }

  /* Drawer 메뉴 스타일 */
  .ant-drawer-body {
    padding: 0 !important;
  }

  /* 컨텐츠 영역 여백 조정 */
  .layout-content,
  main.ant-layout-content.content-ant {
    padding: 0 !important;
  }

  /* ===================================
     2. 카드 레이아웃 개선
     =================================== */

  /* 카드 간격 및 여백 조정 */
  .ant-card {
    margin-bottom: 12px !important;
  }

  .ant-card-body {
    padding: 12px !important;
  }

  .ant-card-head {
    padding: 8px 12px !important;
    min-height: auto !important;
  }

  .ant-card.criclebox {
    border-radius: 8px !important;
  }

  /* Row 간격 조정 */
  .ant-row {
    margin-left: -8px !important;
    margin-right: -8px !important;
  }

  .ant-col {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  /* mb-24 클래스 모바일 조정 */
  .mb-24 {
    margin-bottom: 12px !important;
  }

  /* ===================================
     3. 헤더 영역 개선
     =================================== */

  /* 페이지 헤더 */
  .ant-page-header-heading {
    display: block !important;
  }

  .ant-page-header-heading-title {
    font-size: 18px !important;
    line-height: 24px !important;
    margin-bottom: 8px !important;
  }

  /* Breadcrumb */
  .ant-breadcrumb {
    font-size: 12px !important;
    margin-bottom: 8px !important;
  }

  /* 헤더 컨트롤 영역 전체 */
  .header-control {
    display: flex !important;
    flex-wrap: wrap !important;
    align-items: center !important;
    gap: 8px !important;
    justify-content: flex-end !important;
  }

  /* 아이콘 버튼들 크기 조정 */
  .header-control .ant-badge,
  .header-control .ant-btn-link,
  .header-control .sidebar-toggler,
  .header-control .setting-drwer {
    flex-shrink: 0;
  }

  /* Sign in/out 버튼 */
  .header-control .btn-sign-in {
    font-size: 0 !important;
    padding: 8px !important;
    display: flex !important;
    align-items: center !important;
    gap: 4px !important;
  }

  .header-control .btn-sign-in span {
    display: none !important;
  }

  .header-control .btn-sign-in .anticon,
  .header-control .btn-sign-in svg {
    font-size: 18px !important;
    width: 20px !important;
    height: 20px !important;
  }

  /* 검색창 */
  .header-control .header-search {
    width: 100% !important;
    flex-basis: 100% !important;
    order: 10 !important;
    margin: 0 !important;
  }

  /* 설정 Drawer 버튼 */
  .setting-drwer {
    width: 44px !important;
    height: 44px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    cursor: pointer;
  }

  .setting-drwer svg {
    width: 20px !important;
    height: 20px !important;
  }

  /* Sidebar toggler (햄버거 메뉴) */
  .sidebar-toggler {
    min-width: 44px !important;
    height: 44px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .sidebar-toggler svg {
    width: 20px !important;
    height: 20px !important;
  }

  /* Badge 알림 아이콘 */
  .header-control .ant-badge {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    min-width: 44px !important;
    height: 44px !important;
  }

  .header-control .ant-badge svg {
    width: 20px !important;
    height: 20px !important;
  }

  /* ===================================
     4. 테이블 반응형 개선
     =================================== */

  /* 테이블 가로 스크롤 */
  .ant-table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .ant-table {
    min-width: 600px;
    font-size: 12px !important;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 8px 12px !important;
    white-space: nowrap;
  }

  .ant-table-thead > tr > th {
    font-size: 11px !important;
  }

  .ant-table-tbody > tr > td {
    font-size: 12px !important;
  }

  /* 테이블 페이지네이션 */
  .ant-pagination {
    font-size: 12px !important;
  }

  .ant-pagination-item {
    min-width: 28px !important;
    height: 28px !important;
    line-height: 26px !important;
    margin: 0 2px !important;
  }

  .ant-pagination-options {
    display: none !important; /* 모바일에서 페이지 크기 선택 숨김 */
  }

  /* ===================================
     5. 타이포그래피 조정
     =================================== */

  h1, .h1 {
    font-size: 24px !important;
    line-height: 32px !important;
  }

  h2, .h2 {
    font-size: 20px !important;
    line-height: 28px !important;
  }

  h3, .h3 {
    font-size: 18px !important;
    line-height: 24px !important;
  }

  h4, .h4 {
    font-size: 16px !important;
    line-height: 22px !important;
  }

  h5, .h5 {
    font-size: 14px !important;
    line-height: 20px !important;
  }

  h6, .h6 {
    font-size: 13px !important;
    line-height: 18px !important;
  }

  /* Title 컴포넌트 */
  .ant-typography h1.ant-typography,
  .ant-typography div.ant-typography-h1,
  .ant-typography div.ant-typography-h1 > textarea {
    font-size: 24px !important;
  }

  .ant-typography h3.ant-typography {
    font-size: 18px !important;
  }

  /* ===================================
     6. 버튼 및 입력 필드 개선
     =================================== */

  /* 버튼 크기 조정 */
  .ant-btn {
    height: 36px !important;
    padding: 0 12px !important;
    font-size: 13px !important;
  }

  .ant-btn-sm {
    height: 28px !important;
    padding: 0 8px !important;
    font-size: 12px !important;
  }

  .ant-btn-lg {
    height: 44px !important;
    padding: 0 16px !important;
    font-size: 14px !important;
  }

  /* 입력 필드 */
  .ant-input,
  .ant-select-selector {
    height: 36px !important;
    font-size: 14px !important;
  }

  .ant-input-affix-wrapper {
    height: 36px !important;
  }

  /* 폼 라벨 */
  .ant-form-item-label {
    font-size: 13px !important;
  }

  /* ===================================
     7. 핵심 지표 카드 개선
     =================================== */

  /* 숫자 표시 카드 */
  .number h3 {
    font-size: 20px !important;
    margin-bottom: 4px !important;
  }

  .number span {
    font-size: 12px !important;
  }

  .icon-box {
    width: 36px !important;
    height: 36px !important;
    line-height: 40px !important;
  }

  .icon-box span {
    font-size: 18px !important;
  }

  /* ===================================
     8. 차트 영역 개선
     =================================== */

  /* 차트 컨테이너 */
  .chart-container,
  .apexcharts-canvas {
    width: 100% !important;
    max-width: 100% !important;
  }

  /* 차트 제목 및 설명 */
  .chart-vistior h5,
  .linechart h5 {
    font-size: 14px !important;
  }

  .chart-visitor-count h4 {
    font-size: 18px !important;
  }

  .chart-visitor-count span {
    font-size: 12px !important;
  }

  /* 차트 범례 */
  .sales ul li {
    font-size: 12px !important;
  }

  /* ApexCharts 반응형 조정 */
  .apexcharts-legend {
    font-size: 11px !important;
  }

  .apexcharts-legend-text {
    font-size: 11px !important;
  }

  /* ===================================
     9. 탭 및 메뉴 개선
     =================================== */

  /* 탭 */
  .ant-tabs-tab {
    font-size: 13px !important;
    padding: 8px 12px !important;
  }

  .ant-tabs-nav {
    margin-bottom: 12px !important;
  }

  /* 라디오 버튼 그룹 */
  .ant-radio-button-wrapper {
    height: 32px !important;
    line-height: 30px !important;
    padding: 0 12px !important;
    font-size: 12px !important;
  }

  /* ===================================
     10. Timeline 및 List 개선
     =================================== */

  /* Timeline */
  .timelinelist h5 {
    font-size: 13px !important;
  }

  .timelinelist span {
    font-size: 11px !important;
  }

  .ant-timeline-item {
    padding-bottom: 12px !important;
  }

  /* List */
  .ant-list-item {
    padding: 8px 0 !important;
  }

  .ant-list-item-meta-title {
    font-size: 13px !important;
  }

  .ant-list-item-meta-description {
    font-size: 11px !important;
  }

  /* ===================================
     11. Drawer (모바일 메뉴) 개선
     =================================== */

  /* Drawer 헤더만 패딩 조정 - Body는 섹션 1에서 설정됨 */
  .ant-drawer-header {
    padding: 12px 16px !important;
  }

  /* 설정 Drawer는 패딩 유지 */
  .settings-drawer .ant-drawer-body {
    padding: 16px !important;
  }

  /* ===================================
     12. Tag 및 Badge 개선
     =================================== */

  .ant-tag {
    font-size: 11px !important;
    padding: 2px 8px !important;
    line-height: 18px !important;
  }

  .tag-primary,
  .tag-badge {
    font-size: 11px !important;
    padding: 2px 8px !important;
    line-height: 18px !important;
  }

  /* ===================================
     13. Avatar 및 이미지 개선
     =================================== */

  .ant-avatar {
    width: 32px !important;
    height: 32px !important;
  }

  .ant-avatar-lg {
    width: 40px !important;
    height: 40px !important;
  }

  .shape-avatar {
    margin-right: 12px !important;
  }

  .shape-avatar img {
    width: 40px !important;
    height: 40px !important;
  }

  /* ===================================
     14. Progress Bar 개선
     =================================== */

  .ant-progress-text {
    font-size: 12px !important;
  }

  .percent-progress span.ant-progress-text {
    font-size: 11px !important;
  }

  /* ===================================
     15. Statistic 개선
     =================================== */

  .ant-statistic-title {
    font-size: 12px !important;
  }

  .ant-statistic-content {
    font-size: 18px !important;
  }

  /* ===================================
     16. Space 및 Divider 개선
     =================================== */

  .ant-space {
    gap: 8px !important;
  }

  .ant-divider {
    margin: 12px 0 !important;
  }

  /* ===================================
     17. 특정 페이지 개선
     =================================== */

  /* 로그인/회원가입 페이지 */
  .signin h1 {
    font-size: 32px !important;
  }

  .signin h5 {
    font-size: 16px !important;
  }

  .card-signup {
    margin-top: -100px !important;
    padding: 0 16px !important;
  }

  .sign-up-header {
    height: 400px !important;
    padding-top: 100px !important;
  }

  .sign-up-header .content h1 {
    font-size: 32px !important;
  }

  /* 프로필 페이지 */
  .profile-nav-bg {
    height: 200px !important;
    margin-top: -70px !important;
  }

  .card-profile-head {
    margin: -30px 8px 12px !important;
  }

  .card-profile-head .ant-card-head .ant-avatar {
    width: 60px !important;
    height: 60px !important;
  }

  .card-profile-head .ant-card-head .avatar-info h4 {
    font-size: 18px !important;
  }

  /* ===================================
     18. 유틸리티 클래스 모바일 조정
     =================================== */

  .text-center-mobile {
    text-align: center !important;
  }

  .hide-mobile {
    display: none !important;
  }

  .show-mobile {
    display: block !important;
  }

  /* Flex 유틸리티 */
  .flex-column-mobile {
    flex-direction: column !important;
  }

  .flex-wrap-mobile {
    flex-wrap: wrap !important;
  }

  /* 여백 조정 */
  .p-mobile-0 {
    padding: 0 !important;
  }

  .m-mobile-0 {
    margin: 0 !important;
  }

  /* ===================================
     19. 오버플로우 처리
     =================================== */

  /* 가로 스크롤 허용 */
  .table-responsive,
  .ant-list-box,
  .cardbody {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  /* 텍스트 줄바꿈 */
  .ant-table-tbody > tr > td.wrap-text {
    white-space: normal !important;
    word-break: break-word !important;
  }

  /* ===================================
     20. Footer 개선
     =================================== */

  .footer-menu ul {
    flex-direction: column;
    gap: 4px;
  }

  .footer-menu ul li a {
    padding: 0.25rem 0.5rem !important;
    font-size: 12px !important;
  }

  .copyright {
    font-size: 11px !important;
    text-align: center !important;
  }

  /* ===================================
     21. Home 페이지 특정 개선
     =================================== */

  /* 데이터 기준 시점 카드 */
  .layout-content > .ant-row:first-child .ant-card {
    margin-bottom: 12px !important;
  }

  .layout-content > .ant-row:first-child .ant-space {
    flex-direction: column !important;
    align-items: flex-start !important;
    width: 100% !important;
  }

  .layout-content > .ant-row:first-child .ant-space > .ant-space-item:last-child {
    align-self: flex-end !important;
    margin-top: 8px !important;
  }

  /* 핵심 지표 Row */
  .rowgap-vbox {
    margin-bottom: 0 !important;
  }

  /* ===================================
     22. 반응형 그리드 재정의
     =================================== */

  /* 모바일에서는 모든 컬럼을 full width로 */
  .ant-col-xs-24 {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
}

/* ===================================
   23. 중간 크기 화면 (768px - 991px)
   =================================== */

@media (min-width: 768px) and (max-width: 991px) {
  .layout-dashboard .ant-layout-header {
    margin: 8px 16px !important;
  }

  .layout-dashboard .ant-layout-content {
    margin: 0 16px !important;
  }

  .ant-card-body {
    padding: 16px !important;
  }

  .number h3 {
    font-size: 24px !important;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 12px 16px !important;
  }

  /* 차트 레이아웃 조정 */
  .bar-chart {
    max-width: 100% !important;
  }

  .full-width {
    max-width: 100% !important;
  }
}

/* ===================================
   24. 가로 모드 대응 (모바일 landscape)
   =================================== */

@media (max-width: 767px) and (orientation: landscape) {
  .sign-up-header {
    height: 300px !important;
    padding-top: 80px !important;
  }

  .profile-nav-bg {
    height: 150px !important;
  }

  /* 차트 높이 조정 */
  .ant-card.criclebox.h-full {
    min-height: 250px !important;
  }
}

/* ===================================
   25. 아주 작은 화면 (< 375px)
   =================================== */

@media (max-width: 374px) {
  body {
    font-size: 13px;
  }

  .ant-card-body {
    padding: 10px !important;
  }

  .number h3 {
    font-size: 18px !important;
  }

  .ant-btn {
    padding: 0 10px !important;
    font-size: 12px !important;
  }

  .header-control .header-search {
    font-size: 12px !important;
  }

  /* 매우 작은 화면에서는 일부 요소 숨김 */
  .hide-xs {
    display: none !important;
  }
}

/* ===================================
   26. iOS Safari 특정 수정
   =================================== */

@supports (-webkit-touch-callout: none) {
  /* iOS에서 가로 스크롤 부드럽게 */
  .table-responsive,
  .ant-table-wrapper {
    -webkit-overflow-scrolling: touch;
  }

  /* iOS에서 입력 필드 확대 방지 */
  input,
  select,
  textarea {
    font-size: 16px !important;
  }
}

/* ===================================
   27. 터치 영역 확대 (접근성 개선)
   =================================== */

@media (max-width: 767px) {
  /* 터치 가능한 요소는 최소 44x44px */
  .ant-btn,
  .ant-input,
  .ant-select-selector,
  a.ant-btn,
  button {
    min-height: 44px;
    min-width: 44px;
  }

  /* 작은 버튼은 예외 처리하되 터치 영역 확보 */
  .ant-btn-sm {
    min-height: 36px;
    min-width: 36px;
  }

  /* 아이콘 버튼 터치 영역 */
  .ant-btn-icon-only {
    min-width: 44px !important;
    min-height: 44px !important;
  }
}

/* ===================================
   28. 다크모드 지원 준비 (선택사항)
   =================================== */

@media (prefers-color-scheme: dark) {
  /* 필요시 다크모드 스타일 추가 */
}

/* ===================================
   29. 프린트 모드 (선택사항)
   =================================== */

@media print {
  /* 사이드바, 헤더, 푸터 숨김 */
  .ant-layout-sider,
  .ant-layout-header,
  .ant-layout-footer,
  .header-control {
    display: none !important;
  }

  /* 본문만 표시 */
  .ant-layout-content {
    margin: 0 !important;
    padding: 0 !important;
  }

  /* 페이지 나누기 */
  .ant-card {
    page-break-inside: avoid;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/mobile-responsive.css"],"names":[],"mappings":"AAAA;;;;;CAKC;;AAED;;wCAEwC;;AAExC;EACE,mBAAmB;EACnB;IACE,UAAU;IACV,eAAe;EACjB;;EAEA,eAAe;EACf;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,4BAA4B;IAC5B,wBAAwB;EAC1B;;EAEA,oCAAoC;EACpC;IACE,wBAAwB;EAC1B;;EAEA,4BAA4B;EAC5B;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,oBAAoB;IACpB,qBAAqB;IACrB,uBAAuB;EACzB;;EAEA,sBAAsB;EACtB;IACE,kCAAkC;EACpC;;EAEA,kBAAkB;EAClB;IACE,qBAAqB;EACvB;;EAEA,iBAAiB;EACjB;;IAEE,qBAAqB;EACvB;;EAEA;;0CAEwC;;EAExC,kBAAkB;EAClB;IACE,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA,cAAc;EACd;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA,qBAAqB;EACrB;IACE,8BAA8B;EAChC;;EAEA;;0CAEwC;;EAExC,WAAW;EACX;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA,eAAe;EACf;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA,iBAAiB;EACjB;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,8BAA8B;IAC9B,mBAAmB;IACnB,oCAAoC;EACtC;;EAEA,kBAAkB;EAClB;;;;IAIE,cAAc;EAChB;;EAEA,mBAAmB;EACnB;IACE,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,QAAQ;EACR;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA,iBAAiB;EACjB;IACE,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,6BAA6B;EAC7B;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;EACpC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,iBAAiB;EACjB;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;0CAEwC;;EAExC,eAAe;EACf;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;;IAEE,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,eAAe;EACf;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,4BAA4B;IAC5B,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB,EAAE,uBAAuB;EACnD;;EAEA;;0CAEwC;;EAExC;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA,eAAe;EACf;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;0CAEwC;;EAExC,aAAa;EACb;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA,UAAU;EACV;;IAEE,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA,SAAS;EACT;IACE,0BAA0B;EAC5B;;EAEA;;0CAEwC;;EAExC,aAAa;EACb;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;0CAEwC;;EAExC,YAAY;EACZ;;IAEE,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA,eAAe;EACf;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,UAAU;EACV;IACE,0BAA0B;EAC5B;;EAEA,sBAAsB;EACtB;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;0CAEwC;;EAExC,MAAM;EACN;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;EAChC;;EAEA,cAAc;EACd;IACE,uBAAuB;IACvB,4BAA4B;IAC5B,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;;0CAEwC;;EAExC,aAAa;EACb;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,+BAA+B;EACjC;;EAEA,SAAS;EACT;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;0CAEwC;;EAExC,wCAAwC;EACxC;IACE,6BAA6B;EAC/B;;EAEA,qBAAqB;EACrB;IACE,wBAAwB;EAC1B;;EAEA;;0CAEwC;;EAExC;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;;0CAEwC;;EAExC;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;0CAEwC;;EAExC;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;0CAEwC;;EAExC;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;0CAEwC;;EAExC;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;0CAEwC;;EAExC,iBAAiB;EACjB;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,YAAY;EACZ;IACE,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;0CAEwC;;EAExC;IACE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,cAAc;EACd;IACE,iCAAiC;EACnC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,UAAU;EACV;IACE,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;0CAEwC;;EAExC,cAAc;EACd;;;IAGE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA,YAAY;EACZ;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;;EAEA;;0CAEwC;;EAExC;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,kCAAkC;IAClC,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;;0CAEwC;;EAExC,iBAAiB;EACjB;IACE,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;IACjC,kCAAkC;IAClC,sBAAsB;EACxB;;EAEA;IACE,+BAA+B;IAC/B,0BAA0B;EAC5B;;EAEA,cAAc;EACd;IACE,2BAA2B;EAC7B;;EAEA;;0CAEwC;;EAExC,8BAA8B;EAC9B;IACE,cAAc;IACd,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;;wCAEwC;;AAExC;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA,eAAe;EACf;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;wCAEwC;;AAExC;EACE;IACE,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,aAAa;EACb;IACE,4BAA4B;EAC9B;AACF;;AAEA;;wCAEwC;;AAExC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,yBAAyB;EACzB;IACE,wBAAwB;EAC1B;AACF;;AAEA;;wCAEwC;;AAExC;EACE,sBAAsB;EACtB;;IAEE,iCAAiC;EACnC;;EAEA,sBAAsB;EACtB;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA;;wCAEwC;;AAExC;EACE,0BAA0B;EAC1B;;;;;IAKE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,4BAA4B;EAC5B;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,iBAAiB;EACjB;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA;;wCAEwC;;AAExC;EACE,oBAAoB;AACtB;;AAEA;;wCAEwC;;AAExC;EACE,oBAAoB;EACpB;;;;IAIE,wBAAwB;EAC1B;;EAEA,WAAW;EACX;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA,YAAY;EACZ;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/*!\n=========================================================\n* Mobile Responsive Enhancement for my-hts\n* 모바일 환경 반응형 개선 스타일시트\n=========================================================\n*/\n\n/* ===================================\n   1. 모바일 기본 레이아웃 (< 768px)\n   =================================== */\n\n@media (max-width: 767px) {\n  /* Body 및 기본 레이아웃 */\n  body {\n    padding: 0;\n    font-size: 14px;\n  }\n\n  /* 레이아웃 전체 조정 */\n  .layout-dashboard .ant-layout {\n    margin-left: 0 !important;\n    width: 100% !important;\n  }\n\n  .layout-dashboard .ant-layout-header {\n    margin: 5px 8px !important;\n    padding: 12px !important;\n  }\n\n  .layout-dashboard .ant-layout-content {\n    margin: 0 8px !important;\n    padding: 0 !important;\n  }\n\n  .layout-dashboard .ant-layout-footer {\n    margin: 0 8px 8px !important;\n    padding: 12px !important;\n  }\n\n  /* 사이드바 숨김 처리 (Drawer 밖의 고정 사이드바만) */\n  .layout-dashboard > .ant-layout-sider.sider-primary {\n    display: none !important;\n  }\n\n  /* Drawer 안의 사이드바는 보이도록 설정 */\n  .drawer-sidebar .ant-layout-sider.sider-primary {\n    display: block !important;\n    position: relative !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    height: auto !important;\n  }\n\n  /* Drawer 내부 레이아웃 조정 */\n  .drawer-sidebar .layout-dashboard {\n    background: transparent !important;\n  }\n\n  /* Drawer 메뉴 스타일 */\n  .ant-drawer-body {\n    padding: 0 !important;\n  }\n\n  /* 컨텐츠 영역 여백 조정 */\n  .layout-content,\n  main.ant-layout-content.content-ant {\n    padding: 0 !important;\n  }\n\n  /* ===================================\n     2. 카드 레이아웃 개선\n     =================================== */\n\n  /* 카드 간격 및 여백 조정 */\n  .ant-card {\n    margin-bottom: 12px !important;\n  }\n\n  .ant-card-body {\n    padding: 12px !important;\n  }\n\n  .ant-card-head {\n    padding: 8px 12px !important;\n    min-height: auto !important;\n  }\n\n  .ant-card.criclebox {\n    border-radius: 8px !important;\n  }\n\n  /* Row 간격 조정 */\n  .ant-row {\n    margin-left: -8px !important;\n    margin-right: -8px !important;\n  }\n\n  .ant-col {\n    padding-left: 8px !important;\n    padding-right: 8px !important;\n  }\n\n  /* mb-24 클래스 모바일 조정 */\n  .mb-24 {\n    margin-bottom: 12px !important;\n  }\n\n  /* ===================================\n     3. 헤더 영역 개선\n     =================================== */\n\n  /* 페이지 헤더 */\n  .ant-page-header-heading {\n    display: block !important;\n  }\n\n  .ant-page-header-heading-title {\n    font-size: 18px !important;\n    line-height: 24px !important;\n    margin-bottom: 8px !important;\n  }\n\n  /* Breadcrumb */\n  .ant-breadcrumb {\n    font-size: 12px !important;\n    margin-bottom: 8px !important;\n  }\n\n  /* 헤더 컨트롤 영역 전체 */\n  .header-control {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    align-items: center !important;\n    gap: 8px !important;\n    justify-content: flex-end !important;\n  }\n\n  /* 아이콘 버튼들 크기 조정 */\n  .header-control .ant-badge,\n  .header-control .ant-btn-link,\n  .header-control .sidebar-toggler,\n  .header-control .setting-drwer {\n    flex-shrink: 0;\n  }\n\n  /* Sign in/out 버튼 */\n  .header-control .btn-sign-in {\n    font-size: 0 !important;\n    padding: 8px !important;\n    display: flex !important;\n    align-items: center !important;\n    gap: 4px !important;\n  }\n\n  .header-control .btn-sign-in span {\n    display: none !important;\n  }\n\n  .header-control .btn-sign-in .anticon,\n  .header-control .btn-sign-in svg {\n    font-size: 18px !important;\n    width: 20px !important;\n    height: 20px !important;\n  }\n\n  /* 검색창 */\n  .header-control .header-search {\n    width: 100% !important;\n    flex-basis: 100% !important;\n    order: 10 !important;\n    margin: 0 !important;\n  }\n\n  /* 설정 Drawer 버튼 */\n  .setting-drwer {\n    width: 44px !important;\n    height: 44px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    cursor: pointer;\n  }\n\n  .setting-drwer svg {\n    width: 20px !important;\n    height: 20px !important;\n  }\n\n  /* Sidebar toggler (햄버거 메뉴) */\n  .sidebar-toggler {\n    min-width: 44px !important;\n    height: 44px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n  }\n\n  .sidebar-toggler svg {\n    width: 20px !important;\n    height: 20px !important;\n  }\n\n  /* Badge 알림 아이콘 */\n  .header-control .ant-badge {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    min-width: 44px !important;\n    height: 44px !important;\n  }\n\n  .header-control .ant-badge svg {\n    width: 20px !important;\n    height: 20px !important;\n  }\n\n  /* ===================================\n     4. 테이블 반응형 개선\n     =================================== */\n\n  /* 테이블 가로 스크롤 */\n  .ant-table-wrapper {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .ant-table {\n    min-width: 600px;\n    font-size: 12px !important;\n  }\n\n  .ant-table-thead > tr > th,\n  .ant-table-tbody > tr > td {\n    padding: 8px 12px !important;\n    white-space: nowrap;\n  }\n\n  .ant-table-thead > tr > th {\n    font-size: 11px !important;\n  }\n\n  .ant-table-tbody > tr > td {\n    font-size: 12px !important;\n  }\n\n  /* 테이블 페이지네이션 */\n  .ant-pagination {\n    font-size: 12px !important;\n  }\n\n  .ant-pagination-item {\n    min-width: 28px !important;\n    height: 28px !important;\n    line-height: 26px !important;\n    margin: 0 2px !important;\n  }\n\n  .ant-pagination-options {\n    display: none !important; /* 모바일에서 페이지 크기 선택 숨김 */\n  }\n\n  /* ===================================\n     5. 타이포그래피 조정\n     =================================== */\n\n  h1, .h1 {\n    font-size: 24px !important;\n    line-height: 32px !important;\n  }\n\n  h2, .h2 {\n    font-size: 20px !important;\n    line-height: 28px !important;\n  }\n\n  h3, .h3 {\n    font-size: 18px !important;\n    line-height: 24px !important;\n  }\n\n  h4, .h4 {\n    font-size: 16px !important;\n    line-height: 22px !important;\n  }\n\n  h5, .h5 {\n    font-size: 14px !important;\n    line-height: 20px !important;\n  }\n\n  h6, .h6 {\n    font-size: 13px !important;\n    line-height: 18px !important;\n  }\n\n  /* Title 컴포넌트 */\n  .ant-typography h1.ant-typography,\n  .ant-typography div.ant-typography-h1,\n  .ant-typography div.ant-typography-h1 > textarea {\n    font-size: 24px !important;\n  }\n\n  .ant-typography h3.ant-typography {\n    font-size: 18px !important;\n  }\n\n  /* ===================================\n     6. 버튼 및 입력 필드 개선\n     =================================== */\n\n  /* 버튼 크기 조정 */\n  .ant-btn {\n    height: 36px !important;\n    padding: 0 12px !important;\n    font-size: 13px !important;\n  }\n\n  .ant-btn-sm {\n    height: 28px !important;\n    padding: 0 8px !important;\n    font-size: 12px !important;\n  }\n\n  .ant-btn-lg {\n    height: 44px !important;\n    padding: 0 16px !important;\n    font-size: 14px !important;\n  }\n\n  /* 입력 필드 */\n  .ant-input,\n  .ant-select-selector {\n    height: 36px !important;\n    font-size: 14px !important;\n  }\n\n  .ant-input-affix-wrapper {\n    height: 36px !important;\n  }\n\n  /* 폼 라벨 */\n  .ant-form-item-label {\n    font-size: 13px !important;\n  }\n\n  /* ===================================\n     7. 핵심 지표 카드 개선\n     =================================== */\n\n  /* 숫자 표시 카드 */\n  .number h3 {\n    font-size: 20px !important;\n    margin-bottom: 4px !important;\n  }\n\n  .number span {\n    font-size: 12px !important;\n  }\n\n  .icon-box {\n    width: 36px !important;\n    height: 36px !important;\n    line-height: 40px !important;\n  }\n\n  .icon-box span {\n    font-size: 18px !important;\n  }\n\n  /* ===================================\n     8. 차트 영역 개선\n     =================================== */\n\n  /* 차트 컨테이너 */\n  .chart-container,\n  .apexcharts-canvas {\n    width: 100% !important;\n    max-width: 100% !important;\n  }\n\n  /* 차트 제목 및 설명 */\n  .chart-vistior h5,\n  .linechart h5 {\n    font-size: 14px !important;\n  }\n\n  .chart-visitor-count h4 {\n    font-size: 18px !important;\n  }\n\n  .chart-visitor-count span {\n    font-size: 12px !important;\n  }\n\n  /* 차트 범례 */\n  .sales ul li {\n    font-size: 12px !important;\n  }\n\n  /* ApexCharts 반응형 조정 */\n  .apexcharts-legend {\n    font-size: 11px !important;\n  }\n\n  .apexcharts-legend-text {\n    font-size: 11px !important;\n  }\n\n  /* ===================================\n     9. 탭 및 메뉴 개선\n     =================================== */\n\n  /* 탭 */\n  .ant-tabs-tab {\n    font-size: 13px !important;\n    padding: 8px 12px !important;\n  }\n\n  .ant-tabs-nav {\n    margin-bottom: 12px !important;\n  }\n\n  /* 라디오 버튼 그룹 */\n  .ant-radio-button-wrapper {\n    height: 32px !important;\n    line-height: 30px !important;\n    padding: 0 12px !important;\n    font-size: 12px !important;\n  }\n\n  /* ===================================\n     10. Timeline 및 List 개선\n     =================================== */\n\n  /* Timeline */\n  .timelinelist h5 {\n    font-size: 13px !important;\n  }\n\n  .timelinelist span {\n    font-size: 11px !important;\n  }\n\n  .ant-timeline-item {\n    padding-bottom: 12px !important;\n  }\n\n  /* List */\n  .ant-list-item {\n    padding: 8px 0 !important;\n  }\n\n  .ant-list-item-meta-title {\n    font-size: 13px !important;\n  }\n\n  .ant-list-item-meta-description {\n    font-size: 11px !important;\n  }\n\n  /* ===================================\n     11. Drawer (모바일 메뉴) 개선\n     =================================== */\n\n  /* Drawer 헤더만 패딩 조정 - Body는 섹션 1에서 설정됨 */\n  .ant-drawer-header {\n    padding: 12px 16px !important;\n  }\n\n  /* 설정 Drawer는 패딩 유지 */\n  .settings-drawer .ant-drawer-body {\n    padding: 16px !important;\n  }\n\n  /* ===================================\n     12. Tag 및 Badge 개선\n     =================================== */\n\n  .ant-tag {\n    font-size: 11px !important;\n    padding: 2px 8px !important;\n    line-height: 18px !important;\n  }\n\n  .tag-primary,\n  .tag-badge {\n    font-size: 11px !important;\n    padding: 2px 8px !important;\n    line-height: 18px !important;\n  }\n\n  /* ===================================\n     13. Avatar 및 이미지 개선\n     =================================== */\n\n  .ant-avatar {\n    width: 32px !important;\n    height: 32px !important;\n  }\n\n  .ant-avatar-lg {\n    width: 40px !important;\n    height: 40px !important;\n  }\n\n  .shape-avatar {\n    margin-right: 12px !important;\n  }\n\n  .shape-avatar img {\n    width: 40px !important;\n    height: 40px !important;\n  }\n\n  /* ===================================\n     14. Progress Bar 개선\n     =================================== */\n\n  .ant-progress-text {\n    font-size: 12px !important;\n  }\n\n  .percent-progress span.ant-progress-text {\n    font-size: 11px !important;\n  }\n\n  /* ===================================\n     15. Statistic 개선\n     =================================== */\n\n  .ant-statistic-title {\n    font-size: 12px !important;\n  }\n\n  .ant-statistic-content {\n    font-size: 18px !important;\n  }\n\n  /* ===================================\n     16. Space 및 Divider 개선\n     =================================== */\n\n  .ant-space {\n    gap: 8px !important;\n  }\n\n  .ant-divider {\n    margin: 12px 0 !important;\n  }\n\n  /* ===================================\n     17. 특정 페이지 개선\n     =================================== */\n\n  /* 로그인/회원가입 페이지 */\n  .signin h1 {\n    font-size: 32px !important;\n  }\n\n  .signin h5 {\n    font-size: 16px !important;\n  }\n\n  .card-signup {\n    margin-top: -100px !important;\n    padding: 0 16px !important;\n  }\n\n  .sign-up-header {\n    height: 400px !important;\n    padding-top: 100px !important;\n  }\n\n  .sign-up-header .content h1 {\n    font-size: 32px !important;\n  }\n\n  /* 프로필 페이지 */\n  .profile-nav-bg {\n    height: 200px !important;\n    margin-top: -70px !important;\n  }\n\n  .card-profile-head {\n    margin: -30px 8px 12px !important;\n  }\n\n  .card-profile-head .ant-card-head .ant-avatar {\n    width: 60px !important;\n    height: 60px !important;\n  }\n\n  .card-profile-head .ant-card-head .avatar-info h4 {\n    font-size: 18px !important;\n  }\n\n  /* ===================================\n     18. 유틸리티 클래스 모바일 조정\n     =================================== */\n\n  .text-center-mobile {\n    text-align: center !important;\n  }\n\n  .hide-mobile {\n    display: none !important;\n  }\n\n  .show-mobile {\n    display: block !important;\n  }\n\n  /* Flex 유틸리티 */\n  .flex-column-mobile {\n    flex-direction: column !important;\n  }\n\n  .flex-wrap-mobile {\n    flex-wrap: wrap !important;\n  }\n\n  /* 여백 조정 */\n  .p-mobile-0 {\n    padding: 0 !important;\n  }\n\n  .m-mobile-0 {\n    margin: 0 !important;\n  }\n\n  /* ===================================\n     19. 오버플로우 처리\n     =================================== */\n\n  /* 가로 스크롤 허용 */\n  .table-responsive,\n  .ant-list-box,\n  .cardbody {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  /* 텍스트 줄바꿈 */\n  .ant-table-tbody > tr > td.wrap-text {\n    white-space: normal !important;\n    word-break: break-word !important;\n  }\n\n  /* ===================================\n     20. Footer 개선\n     =================================== */\n\n  .footer-menu ul {\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .footer-menu ul li a {\n    padding: 0.25rem 0.5rem !important;\n    font-size: 12px !important;\n  }\n\n  .copyright {\n    font-size: 11px !important;\n    text-align: center !important;\n  }\n\n  /* ===================================\n     21. Home 페이지 특정 개선\n     =================================== */\n\n  /* 데이터 기준 시점 카드 */\n  .layout-content > .ant-row:first-child .ant-card {\n    margin-bottom: 12px !important;\n  }\n\n  .layout-content > .ant-row:first-child .ant-space {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    width: 100% !important;\n  }\n\n  .layout-content > .ant-row:first-child .ant-space > .ant-space-item:last-child {\n    align-self: flex-end !important;\n    margin-top: 8px !important;\n  }\n\n  /* 핵심 지표 Row */\n  .rowgap-vbox {\n    margin-bottom: 0 !important;\n  }\n\n  /* ===================================\n     22. 반응형 그리드 재정의\n     =================================== */\n\n  /* 모바일에서는 모든 컬럼을 full width로 */\n  .ant-col-xs-24 {\n    display: block;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n}\n\n/* ===================================\n   23. 중간 크기 화면 (768px - 991px)\n   =================================== */\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .layout-dashboard .ant-layout-header {\n    margin: 8px 16px !important;\n  }\n\n  .layout-dashboard .ant-layout-content {\n    margin: 0 16px !important;\n  }\n\n  .ant-card-body {\n    padding: 16px !important;\n  }\n\n  .number h3 {\n    font-size: 24px !important;\n  }\n\n  .ant-table-thead > tr > th,\n  .ant-table-tbody > tr > td {\n    padding: 12px 16px !important;\n  }\n\n  /* 차트 레이아웃 조정 */\n  .bar-chart {\n    max-width: 100% !important;\n  }\n\n  .full-width {\n    max-width: 100% !important;\n  }\n}\n\n/* ===================================\n   24. 가로 모드 대응 (모바일 landscape)\n   =================================== */\n\n@media (max-width: 767px) and (orientation: landscape) {\n  .sign-up-header {\n    height: 300px !important;\n    padding-top: 80px !important;\n  }\n\n  .profile-nav-bg {\n    height: 150px !important;\n  }\n\n  /* 차트 높이 조정 */\n  .ant-card.criclebox.h-full {\n    min-height: 250px !important;\n  }\n}\n\n/* ===================================\n   25. 아주 작은 화면 (< 375px)\n   =================================== */\n\n@media (max-width: 374px) {\n  body {\n    font-size: 13px;\n  }\n\n  .ant-card-body {\n    padding: 10px !important;\n  }\n\n  .number h3 {\n    font-size: 18px !important;\n  }\n\n  .ant-btn {\n    padding: 0 10px !important;\n    font-size: 12px !important;\n  }\n\n  .header-control .header-search {\n    font-size: 12px !important;\n  }\n\n  /* 매우 작은 화면에서는 일부 요소 숨김 */\n  .hide-xs {\n    display: none !important;\n  }\n}\n\n/* ===================================\n   26. iOS Safari 특정 수정\n   =================================== */\n\n@supports (-webkit-touch-callout: none) {\n  /* iOS에서 가로 스크롤 부드럽게 */\n  .table-responsive,\n  .ant-table-wrapper {\n    -webkit-overflow-scrolling: touch;\n  }\n\n  /* iOS에서 입력 필드 확대 방지 */\n  input,\n  select,\n  textarea {\n    font-size: 16px !important;\n  }\n}\n\n/* ===================================\n   27. 터치 영역 확대 (접근성 개선)\n   =================================== */\n\n@media (max-width: 767px) {\n  /* 터치 가능한 요소는 최소 44x44px */\n  .ant-btn,\n  .ant-input,\n  .ant-select-selector,\n  a.ant-btn,\n  button {\n    min-height: 44px;\n    min-width: 44px;\n  }\n\n  /* 작은 버튼은 예외 처리하되 터치 영역 확보 */\n  .ant-btn-sm {\n    min-height: 36px;\n    min-width: 36px;\n  }\n\n  /* 아이콘 버튼 터치 영역 */\n  .ant-btn-icon-only {\n    min-width: 44px !important;\n    min-height: 44px !important;\n  }\n}\n\n/* ===================================\n   28. 다크모드 지원 준비 (선택사항)\n   =================================== */\n\n@media (prefers-color-scheme: dark) {\n  /* 필요시 다크모드 스타일 추가 */\n}\n\n/* ===================================\n   29. 프린트 모드 (선택사항)\n   =================================== */\n\n@media print {\n  /* 사이드바, 헤더, 푸터 숨김 */\n  .ant-layout-sider,\n  .ant-layout-header,\n  .ant-layout-footer,\n  .header-control {\n    display: none !important;\n  }\n\n  /* 본문만 표시 */\n  .ant-layout-content {\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  /* 페이지 나누기 */\n  .ant-card {\n    page-break-inside: avoid;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
